import { render, staticRenderFns } from "./Representative.vue?vue&type=template&id=7dc0dbbc&scoped=true&"
import script from "./Representative.vue?vue&type=script&lang=js&"
export * from "./Representative.vue?vue&type=script&lang=js&"
import style0 from "./Representative.vue?vue&type=style&index=0&id=7dc0dbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc0dbbc",
  null
  
)

export default component.exports